/**
 * 回傳網站網域
 * @param locale: 語系, ENVIRONMENT: 目前的ENV
 * @returns String
 */

const provideDomain = (locale: EnumLocale, ENVIRONMENT: string): string => {
  if (locale === EnumLocale.ZH_CN) {
    switch (ENVIRONMENT) {
      case 'PRODUCTION':
        return 'https://wise-iot.advantech.com.cn';
      case 'STAGING':
        return 'https://staging-wise-iot.advantech.com.cn';
      default:
        return 'https://dev-wise-iot.advantech.com.cn';
    }
  } else {
    switch (ENVIRONMENT) {
      case 'PRODUCTION':
        return 'https://wise.advantech.com';
      case 'STAGING':
        return 'https://staging-wise.advantech.com';
      default:
        return 'https://dev-wise.advantech.com';
    }
  }
};

export default provideDomain;
